import type { TablePaginationProps } from '@mui/material/TablePagination';
import i18next from 'i18next';

/**
 * Shared i18n props for MUI {@link TablePagination} (row count label, range text, nav button aria-labels).
 */
export function getMuiTablePaginationI18nProps(): Pick<TablePaginationProps, 'labelRowsPerPage' | 'labelDisplayedRows' | 'getItemAriaLabel'> {
  return {
    labelRowsPerPage: String(i18next.t('statistics-rows-per-page')),
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} ${i18next.t('generic-of')} ${count !== -1 ? count : `${i18next.t('statistics-more-than')} ${to}`}`,
    getItemAriaLabel: (type) => {
      if (type === 'first') return String(i18next.t('table-pagination-first-page'));
      if (type === 'last') return String(i18next.t('table-pagination-last-page'));
      if (type === 'next') return String(i18next.t('table-pagination-next-page'));
      if (type === 'previous') return String(i18next.t('table-pagination-previous-page'));
      return '';
    },
  };
}
